import { PaymentParamsAction, PaymentParamsState } from "./payment.params.types";

export const paymentParamsSetAction = (params: Partial<PaymentParamsState>): PaymentParamsAction => ({ type: 'PAYMENT_PARAMS_SET', params })

export const paymentParamsClearAction = (): PaymentParamsAction => ({ type: 'PAYMENT_PARAMS_CLEAR' })

export const paymentParamsMakePaymentAction = (): PaymentParamsAction => ({ type: 'PAYMENT_PARAMS_MAKE_PAYMENT' })